import React, { useState } from 'react';
import { Mail, Check, Loader2 } from 'lucide-react';
export function WaitlistForm() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [companySize, setCompanySize] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setEmail('');
      setName('');
      setCompanySize('');
    }, 1500);
  };
  return <section id="waitlist" className="py-24 bg-slate-50" data-id="element-302">
      <div className="container mx-auto px-4 max-w-xl" data-id="element-303">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-slate-100" data-id="element-304">
          <div className="text-center mb-8" data-id="element-305">
            <h2 className="text-3xl font-bold text-slate-900 mb-3" data-id="element-306">
              Join the Beta Waitlist
            </h2>
            <p className="text-slate-600" data-id="element-307">
              Be the first to access the ATD Platform and get exclusive
              resources on engineering org design.
            </p>
          </div>

          {status === 'success' ? <div className="bg-green-50 border border-green-100 rounded-xl p-8 text-center animate-in fade-in zoom-in" data-id="element-308">
              <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-309">
                <Check className="h-8 w-8" data-id="element-310" />
              </div>
              <h3 className="text-2xl font-bold text-green-800 mb-2" data-id="element-311">
                You're on the list!
              </h3>
              <p className="text-green-700" data-id="element-312">
                Thanks for joining. We'll be in touch soon with your early
                access invite.
              </p>
              <button onClick={() => setStatus('idle')} className="mt-6 text-sm font-medium text-green-700 hover:text-green-800 underline" data-id="element-313">
                Register another email
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-314">
              <div data-id="element-315">
                <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-316">
                  Full Name (Optional)
                </label>
                <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all" placeholder="Jane Doe" data-id="element-317" />
              </div>

              <div data-id="element-318">
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-319">
                  Work Email <span className="text-red-500" data-id="element-320">*</span>
                </label>
                <div className="relative" data-id="element-321">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-322" />
                  <input type="email" id="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all" placeholder="jane@company.com" data-id="element-323" />
                </div>
              </div>

              <div data-id="element-324">
                <label htmlFor="size" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-325">
                  Company Size (Optional)
                </label>
                <select id="size" value={companySize} onChange={e => setCompanySize(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all bg-white" data-id="element-326">
                  <option value="" data-id="element-327">Select size...</option>
                  <option value="1-50" data-id="element-328">1-50 employees</option>
                  <option value="50-200" data-id="element-329">50-200 employees</option>
                  <option value="200-500" data-id="element-330">200-500 employees</option>
                  <option value="500+" data-id="element-331">500+ employees</option>
                </select>
              </div>

              <button type="submit" disabled={status === 'loading'} className="w-full bg-indigo-600 text-white font-bold py-3 rounded-lg hover:bg-indigo-700 transition-colors shadow-md disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center" data-id="element-332">
                {status === 'loading' ? <>
                    <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-333" />
                    Joining...
                  </> : 'Join Waitlist'}
              </button>

              <p className="text-xs text-center text-slate-500 mt-4" data-id="element-334">
                We respect your privacy. No spam, ever. Unsubscribe at any time.
              </p>
            </form>}
        </div>
      </div>
    </section>;
}